import React from 'react';

const Overlay = ({ isActive, onClick }) => (
  <div id="page-overlay" className={isActive ? 'is-active' : ''} onClick={onClick}></div>
);

export default Overlay;


// WEBPACK FOOTER //
// ./src/components/overlay.js